import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F1120SchJService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: GET request for loading modal data (following F1120 pattern)
  getScheduleJData(
    baseUrl: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    // Use the exact endpoint from AngularJS service (action_code=s4yf8z)
    const url = `${baseUrl}/loadJsonObject?action_code=s4yf8z`;

    // Build params exactly like AngularJS
    let params = _.merge({}, filterParams);
    
    // Add required parameters from AngularJS service
    params.sso_id = globalService?.userSettingsData?.user?.sso_id;
    params.screen_key = globalService?.globalParams?.screen_key;
    params.jcd_key = 250; // From AngularJS service
    params.form_name = 'F1120'; // From AngularJS service
    params.schedule_name = 'J'; // From AngularJS service
    params.fg_key = 2; // From AngularJS service

    console.log('🔧 F1120SchJ - Loading data with params:', params);

    return this.http.get<any>(url, { params });
  }

  // 🚀 CRITICAL: POST request for saving modal data (following AngularJS pattern EXACTLY)
  saveScheduleJData(
    baseUrl: string,
    modalData: any[],
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    
    const url = `${baseUrl}/saveJsonObject?action_code=9qa2sc`;

    // Use clob_setting (singular) like AngularJS
    const clob_setting = {
      tax_year: parseInt(filterParams.tax_year)
    };
    
    // Start with globalParams and filterParams like AngularJS factory (line 52)
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // Add core clob data - exact match with AngularJS
    params.clob_setting = JSON.stringify(clob_setting);
    params.clob_data = JSON.stringify(modalData);
    
    // Essential parameters that MUST be present (from error message)
    params.tax_year = filterParams.tax_year || params.tax_year;
    params.scenario = filterParams.scenario || params.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || 250; // From AngularJS factory line 27
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";
    
    // Additional parameters from AngularJS payload
    params.screen_key = filterParams.screen_key || params.screen_key;
    params.jcd_ta_key = filterParams.jcd_ta_key || params.jcd_ta_key;
    params.activity_key = filterParams.activity_key || params.activity_key;
    params.screen_type = filterParams.screen_type || params.screen_type || "grid";
    params.is_locked = filterParams.is_locked || params.is_locked || "N";
    params.issue_id = filterParams.issue_id || params.issue_id || "";
    params.issue_short_desc = filterParams.issue_short_desc || params.issue_short_desc || "";
    params.issue_id_for_tx_save = filterParams.issue_id_for_tx_save || params.issue_id_for_tx_save || "";
    params.filing_key = filterParams.filing_key || params.filing_key || 0;
    params.ho_le_key = modalData[0]?.HO_LE_KEY || modalData[0]?.LE_KEY;
    params.combination_key = modalData[0]?.COMBINATION_KEY;
    params.process_name = "schedulej-consol-amounts-save";
    
    // parent_me_string from AngularJS payload
    if (filterParams.parent_me_string || params.parent_me_string) {
      params.parent_me_string = filterParams.parent_me_string || params.parent_me_string;
    }
    
    // Build checkLockedbj exactly like AngularJS
    const checkLockedbj = [{
      "leid": modalData[0]?.LEID,
      "cdr_number": modalData[0]?.CDR_NO,
      "consol_group_key": modalData[0]?.CONSOL_GROUP_KEY,
      "reporting_period": modalData[0]?.REPORTING_PERIOD,
      "combination_key": modalData[0]?.COMBINATION_KEY,
      "scenario_key": parseInt(filterParams.scenario)
    }];
    
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    console.log('🔧 F1120SchJ - INPUT filterParams:', filterParams);
    console.log('🔧 F1120SchJ - INPUT globalService.globalParams:', globalService?.globalParams);
    console.log('🔧 F1120SchJ - FINAL params for save:', params);
    
    // Debug essential params
    console.log('🚨 ESSENTIAL PARAMS CHECK:');
    console.log('  tax_year:', params.tax_year);
    console.log('  scenario:', params.scenario);
    console.log('  jcd_key:', params.jcd_key);
    console.log('  scenarioCode:', params.scenarioCode);
    console.log('  is_issue_key_enabled:', params.is_issue_key_enabled);

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded like AngularJS
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
